import { Route } from '@/app/router'

const DeliverySheet = () => import('./index.vue')

export default new Route('/delivery-sheets/:id', DeliverySheet)
	.as('Dashboard:DeliverySheet')
	.permissions(['VIEW_OEM_DELIVERY_SHEET', 'OEM_ENABLED'])
